// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/main.less';

import Vue from 'vue';
import App from '@/App';
import router from '@/router';
import data from '@/config';
import Vuex from 'vuex';
import store from '@/vuex/store';
import toastr from 'vue-toastr';
import autoProgress from 'vue-auto-progress';
import modal from '@/components/modal';
import FieldValidation from '@/components/field-validation';
import ptBR from 'vee-validate/dist/locale/pt_BR';
import datePicker from 'vue-bootstrap-datetimepicker';
import VueMask from 'v-mask';
import money from 'v-money';
import '@/filters/filters';
import VueDirectiveTooltip from 'vue-directive-tooltip';
import { TheMask } from 'vue-the-mask';
import semAcentos from './directives/semAcentos';

window.jQuery = require('jquery');
require('bootstrap');
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css';

Vue.use(Vuex);
Vue.use(datePicker);
Vue.use(VueMask);
//Vue.directive('sem-acentos', semAcentos);
Vue.directive('sem-acentos', {
  bind(el, binding, vnode) {
    const aplicar = (elemento) => {
      elemento.addEventListener('input', (e) => {
        let valor = e.target.value;

        const limpo = valor
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-zA-Z0-9\s]/g, '');

        if (valor !== limpo) {
          e.target.value = limpo;

          // 🔥 atualiza o v-model
          if (binding.expression) {
            vnode.context[binding.expression] = limpo;
          }

          elemento.dispatchEvent(new Event('input'));
        }
      });
    };

    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
      aplicar(el);
    } else {
      el.querySelectorAll('input, textarea').forEach(aplicar);
    }
  }
});
Vue.use(money, { decimal: ',', thousands: '.', precision: 2 });
Vue.use(VueDirectiveTooltip, {
  delay: 100,
  class: 'tooltip-custom',
  triggers: ['hover'],
});
Vue.use(TheMask);

Vue.config.productionTip = false;

FieldValidation.locale(ptBR, 'pt_BR');
Vue.component('field-validation', FieldValidation);

Vue.prototype.$eventBus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data,
  template:
    '<div><App/><modal ref="modal" /><toastr ref="toastr" /><auto-progress /></div>',
  components: { App, modal, toastr, autoProgress },
});



// WEBPACK FOOTER //
// ./src/main.js